import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const EmojiWrapper = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  margin-right: 6px;
`;

export const TitleWrapper = styled.span`
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.black6};
`;
